// redux/states/stateSlice.js
import { createSlice } from "@reduxjs/toolkit";
import estados from "./data/states.json"

const stateSlice = createSlice({
    name: "states",
    initialState: {
        list: estados,
    },
    reducers: {},
});

export default stateSlice.reducer;
